import React, { useEffect, useState } from "react";
import api, { formatApiError, asArray } from "../../lib/api";
import { Plus, Trash2, X } from "lucide-react";
import { toast } from "sonner";

const inputCls = "w-full bg-transparent border-b border-black/15 focus:border-[#0060A7] outline-none py-2";
const ROLES = ["super_admin", "editor", "news_editor"];

export default function AdminUsers() {
    const [items, setItems] = useState([]);
    const [creating, setCreating] = useState(null);

    const load = async () => { try { setItems(asArray((await api.get("/admin/users")).data, "users")); } catch (e) { toast.error(formatApiError(e)); } };
    useEffect(() => { load(); }, []);

    const create = async () => {
        try {
            await api.post("/admin/users", creating);
            toast.success("User created");
            setCreating(null); load();
        } catch (e) { toast.error(formatApiError(e)); }
    };

    const updateRole = async (id, role) => {
        try { await api.patch(`/admin/users/${id}`, { role }); load(); } catch (e) { toast.error(formatApiError(e)); }
    };
    const remove = async (id) => {
        if (!window.confirm("Delete user?")) return;
        try { await api.delete(`/admin/users/${id}`); load(); } catch (e) { toast.error(formatApiError(e)); }
    };

    return (
        <div data-testid="admin-users-page">
            <div className="flex items-center justify-between mb-6">
                <h1 className="heading text-3xl tracking-tight">Admin Users</h1>
                <button onClick={() => setCreating({ email: "", password: "", name: "", role: "editor" })} data-testid="add-user-btn" className="bg-[#002951] hover:bg-[#0060A7] text-white px-5 py-2.5 text-sm inline-flex items-center gap-2"><Plus size={14} /> New User</button>
            </div>

            {creating && (
                <div className="bg-white p-8 mb-6" data-testid="user-create-form">
                    <div className="flex items-center justify-between mb-6">
                        <h2 className="heading text-2xl">New User</h2>
                        <button onClick={() => setCreating(null)} className="text-sm text-[#6B7280] inline-flex items-center gap-2"><X size={14} /> Cancel</button>
                    </div>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                        <div><label className="text-xs uppercase tracking-[0.2em] text-[#6B7280]">Email</label><input data-testid="user-email" type="email" className={inputCls} value={creating.email} onChange={(e) => setCreating({ ...creating, email: e.target.value })} /></div>
                        <div><label className="text-xs uppercase tracking-[0.2em] text-[#6B7280]">Name</label><input data-testid="user-name" className={inputCls} value={creating.name} onChange={(e) => setCreating({ ...creating, name: e.target.value })} /></div>
                        <div><label className="text-xs uppercase tracking-[0.2em] text-[#6B7280]">Password</label><input data-testid="user-password" type="password" className={inputCls} value={creating.password} onChange={(e) => setCreating({ ...creating, password: e.target.value })} /></div>
                        <div>
                            <label className="text-xs uppercase tracking-[0.2em] text-[#6B7280]">Role</label>
                            <select data-testid="user-role" className={inputCls} value={creating.role} onChange={(e) => setCreating({ ...creating, role: e.target.value })}>
                                {ROLES.map((r) => <option key={r} value={r}>{r}</option>)}
                            </select>
                        </div>
                    </div>
                    <button onClick={create} data-testid="user-create-submit" className="mt-6 bg-[#002951] hover:bg-[#0060A7] text-white px-8 py-3 text-sm uppercase tracking-[0.2em]">Create</button>
                </div>
            )}

            <div className="bg-white">
                <table className="w-full text-sm">
                    <thead className="bg-[#EFF0F1] text-left text-xs uppercase tracking-[0.2em] text-[#6B7280]"><tr><th className="p-4">Name</th><th className="p-4">Email</th><th className="p-4">Role</th><th className="p-4"></th></tr></thead>
                    <tbody>
                        {items.map((u) => (
                            <tr key={u.id} className="border-t border-black/5" data-testid={`user-row-${u.email}`}>
                                <td className="p-4 heading">{u.name}</td>
                                <td className="p-4 text-[#6B7280]">{u.email}</td>
                                <td className="p-4">
                                    <select value={u.role} onChange={(e) => updateRole(u.id, e.target.value)} className="border border-black/10 px-2 py-1 text-xs">
                                        {ROLES.map((r) => <option key={r} value={r}>{r}</option>)}
                                    </select>
                                </td>
                                <td className="p-4 text-right">
                                    <button onClick={() => remove(u.id)} className="text-red-500"><Trash2 size={16} /></button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
}
